import { useState } from "react";
import { Check, Minus, Plus, Tags } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const MoodPicker = ({ m, paths, testid, label }) => {
  const [name, setName] = useState("");
  const state = (mood) => {
    const n = paths.filter((p) => m.moods[p]?.includes(mood)).length;
    return n === 0 ? "none" : n === paths.length ? "all" : "some";
  };
  const create = () => { const v = m.moodOps.create(name); if (v) { m.moodOps.set(paths, v, true); setName(""); } };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button title="Change moods" className={label ? "inline-flex items-center gap-1 rounded border border-[#2D3442] px-2 py-0.5 text-[11px] text-[#D6CCBC] hover:border-[#D97706]/50" : "rounded p-1 text-[#7A7468] hover:text-[#F3EBDD]"} data-testid={testid}>
          <Tags className="h-3.5 w-3.5" />{label}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-60 p-2" data-testid={`${testid}-popover`}>
        <div className="mb-1.5 px-1 text-[11px] text-[#A8A090]">Moods for {paths.length === 1 ? "this song" : `${paths.length} songs`}</div>
        <div className="flex max-h-56 flex-wrap gap-1 overflow-y-auto">
          {m.allMoods.map((mood) => {
            const s = state(mood);
            return (
              <button key={mood} onClick={() => m.moodOps.set(paths, mood, s !== "all")}
                className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] transition-colors ${s === "all" ? "bg-[#D97706] text-[#0B0D10]" : s === "some" ? "border border-[#D97706] text-[#FBBF24]" : "border border-[#2D3442] text-[#A8A090] hover:border-[#D97706]/50"}`}
                data-testid={`${testid}-mood-${mood}`}>
                {s === "all" ? <Check className="h-3 w-3" /> : s === "some" ? <Minus className="h-3 w-3" /> : null}{mood}
              </button>
            );
          })}
        </div>
        <div className="mt-2 flex gap-1 border-t border-[#2D3442] pt-2">
          <input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && create()} maxLength={30} placeholder="New mood…" className="min-w-0 flex-1 rounded border border-[#2D3442] bg-transparent px-1.5 py-0.5 text-[11px] text-[#F3EBDD]" data-testid={`${testid}-new-mood`} />
          <button onClick={create} disabled={!name.trim()} className="rounded bg-[#D97706] px-1.5 text-[#0B0D10] disabled:opacity-40" data-testid={`${testid}-new-mood-add`}><Plus className="h-3 w-3" /></button>
        </div>
      </PopoverContent>
    </Popover>
  );
};
